// // import React, { useState } from 'react';
// // import MicrosoftLogin from 'react-microsoft-login';
// // import {
// //   MICROSOFT_TENANT_URL,
// //   MICROSOFT_CLIENT_ID,
// //   MICROSOFT_REDIRECT_URI
// // } from '../../../constants';
// // /**
// //  * Renders a button which, when selected, will open a popup for login
// //  */
// // export const MicrosoftSignInButton = () => {
// //   let currentTheme = localStorage.getItem('appTheme')
// //     ? localStorage.getItem('appTheme').toLowerCase()
// //     : 'light';
// //   const [clientId, onClientIdChange] = useState(MICROSOFT_CLIENT_ID);
// //   const [callbackUrl, onCallbackUrlChange] = useState(
// //     MICROSOFT_REDIRECT_URI || window.location.href
// //   );
// //   const [msalInstance, onMsalInstanceChange] = useState();

// //   const loginHandler = (err, data, msal) => {
// //     localStorage.setItem('signin_type', 'microsoft');
// //     if ((err.name = 'ClientAuthError')) {
// //       console.log('Authentication in progress');
// //     }
// //     if (!err && data) {
// //       console.log('this is data', data);
// //       onMsalInstanceChange(msal);
// //       localStorage.setItem('signing_in', false);
// //     }
// //   };

// //   const logoutHandler = () => {
// //     msalInstance.logout();
// //   };

// //   const handleOnclick = () => {
// //     console.log('ms button got clicked lterally');
// //     localStorage.setItem('signin_type', 'microsoft');
// //     localStorage.setItem('signing_in', true);
// //   };
// //   return msalInstance ? (
// //     <button onClick={logoutHandler}>Logout</button>
// //   ) : (
// //     <div onClick={handleOnclick}>
// //       <MicrosoftLogin
// //         clientId={clientId}
// //         tenantUrl={MICROSOFT_TENANT_URL}
// //         redirectUri={callbackUrl}
// //         authCallback={loginHandler}
// //         forceRedirectStrategy={true}
// //         useLocalStorageCache={false}
// //         withUserData={true}
// //         buttonTheme={`${currentTheme}_short`}
// //       />
// //     </div>
// //   );
// // };

// // new code
// import React, { useEffect, useState } from 'react';
// import { PublicClientApplication } from '@azure/msal-browser';
// import {
//   MICROSOFT_CLIENT_ID,
//   MICROSOFT_REDIRECT_URI,
//   MICROSOFT_TENANT_URL
// } from '../../../constants';
// import { msalInstance } from 'src/index';

// // const msalConfig = {
// //   auth: {
// //     clientId: MICROSOFT_CLIENT_ID,
// //     authority: MICROSOFT_TENANT_URL,
// //     redirectUri: MICROSOFT_REDIRECT_URI || window.location.href
// //   },
// //   cache: {
// //     cacheLocation: 'localStorage',
// //     storeAuthStateInCookie: true
// //   }
// // };

// // const msalInstance = new PublicClientApplication(msalConfig);

// export const MicrosoftSignInButton = () => {
//   const [account, setAccount] = useState(null);

//   useEffect(() => {
//     // msalInstance
//     //   .handleRedirectPromise()
//     //   .then((response) => {
//     //     if (response) {
//     //       setAccount(response.account);
//     //       localStorage.setItem('signin_type', 'microsoft');
//     //       localStorage.setItem('signing_in', false);
//     //     } else {
//     //       const accounts = msalInstance.getAllAccounts();
//     //       if (accounts.length > 0) {
//     //         setAccount(accounts[0]);
//     //       }
//     //     }
//     //   })
//     //   .catch((error) => {
//     //     console.error('Login error: ', error);
//     //   });

//     const loginRequest = {
//       scopes: ['user.read']
//     };

//     msalInstance.loginRedirect(loginRequest);
//   }, []);

//   const handleLogin = () => {
//     msalInstance.loginRedirect({ scopes: ['user.read'] });
//   };

//   const handleLogout = () => {
//     msalInstance.logout();
//     setAccount(null);
//   };

//   return account ? (
//     <button onClick={handleLogout}>Logout</button>
//   ) : (
//     <button onClick={handleLogin}>
//       <span>Sign in with Microsoft</span>
//     </button>
//   );
// };

import React, { useEffect, useState } from 'react';

import { useMsal } from '@azure/msal-react';
import { tokenRequest } from 'src/msal-constants';

export const MicrosoftSignInButton = () => {
  const { instance, accounts } = useMsal();
  const handleLogin = async (instance) => {
    await instance
      .loginRedirect(tokenRequest)
      .then((res) => {
        console.log(res, 'solution ...');
      })
      .catch((e) => {
        console.error(e, 'Login error');
      });
  };

  useEffect(() => {
    if (!accounts[0]) {
      handleLogin(instance);
    }
  }, []);

  // TODO: clean the code after testing

  return (
    <></>
    // <Button type="dashed" icon={<LoginOutlined />} style={{width:'150px',color:'green',borderColor:'green'}} onClick={() => handleLogin(instance)}>Sign in</Button>
  );
};
